import {simpleAction} from "../../utils";
import * as TYPES from "./types";

/**
 * Request Products
 * @type {function(type: string): {type: string, payload: any}}
 */
export const transactionsGetRequest = simpleAction(TYPES.TRANSACTIONS_GET_REQUEST);

/**
 * Request transactions success
 * @param payload
 * @type {function(type: string): {type: string, payload: any}}
 */
export const transactionsGetSuccess = simpleAction(TYPES.TRANSACTIONS_GET_SUCCESS);

/**
 * Request transactions error
 * @type {function(type: string): {type: string, payload: any}}
 */
export const transactionsGetError = simpleAction(TYPES.TRANSACTIONS_GET_FAIL);

/**
 * Request Product
 * @type {function(type: string): {type: string, payload: any}}
 */
export const transactionLoadRequest = simpleAction(TYPES.TRANSACTION_LOAD_REQUEST);

/**
 * Request Product success
 * @param payload
 * @type {function(type: string): {type: string, payload: any}}
 */
export const transactionLoadSuccess = simpleAction(TYPES.TRANSACTION_LOAD_SUCCESS);

/**
 * Request Product error
 * @type {function(type: string): {type: string, payload: any}}
 */
export const transactionLoadError = simpleAction(TYPES.TRANSACTION_LOAD_FAIL);

/**
 * Create Product
 * @type {function(type: string): {type: string, payload: any}}
 */
export const transactionCreateRequest = simpleAction(TYPES.TRANSACTION_CREATE_REQUEST);

/**
 * Create Product Success
 * @param payload
 * @type {function(type: string): {type: string, payload: any}}
 */
export const transactionCreateSuccess = simpleAction(TYPES.TRANSACTION_CREATE_SUCCESS);

/**
 * Create Product Error
 * @type {function(type: string): {type: string, payload: any}}
 */
export const transactionCreateError = simpleAction(TYPES.TRANSACTION_CREATE_FAIL);

/**
 * Update Product
 * @type {function(type: string): {type: string, payload: any}}
 */
export const transactionUpdateRequest = simpleAction(TYPES.TRANSACTION_UPDATE_REQUEST);

/**
 * Update Product Success
 * @param payload
 * @type {function(type: string): {type: string, payload: any}}
 */
export const transactionUpdateSuccess = simpleAction(TYPES.TRANSACTION_UPDATE_SUCCESS);

/**
 * Update Product Error
 * @type {function(type: string): {type: string, payload: any}}
 */
export const transactionUpdateError = simpleAction(TYPES.TRANSACTION_UPDATE_FAIL);
